import React, { useContext } from 'react';
import { CotizadorContext } from '../context';
import useCarsData from './useCarsData';
import useExtrasData from './useExtrasData';
import useRentTimeData from './useRentTimeData';
import useDeliveryData from './useDeliveryData';


const useContactData = () => {
    const [state, setState] = useContext(CotizadorContext)

    const { getSelectedCar } = useCarsData();
    const { getSelectedUnitLabel, amount } = useRentTimeData();
    const { selectedExtras, getExtraItem } = useExtrasData();
    const { delivery } = useDeliveryData();

    const contactData = {
        modelo: getSelectedCar() ? getSelectedCar().name : '',
        tiempo: amount > 0 ? `${amount} ${getSelectedUnitLabel()}` : '',
        delivery,
        extras: selectedExtras.map(extra => getExtraItem(extra).name)
    }

    return {
        contactData
    };
}

export default useContactData;